var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-work-space"},[_c('WorkSpaceList',{attrs:{"work-spaces":_vm.companies},on:{"select":function($event){return _vm.selectHandler($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }